/** Power-law only-up curve (α=2). Spot: p(s) = 0.01 * (1 + s/300_000)^2 */
export const MMK_CURVE_P0 = 0.01;
export const MMK_CURVE_SCALE = 300_000;

export function mmkSpotPrice(soldWhole: number): number {
	const s = Math.max(0, soldWhole);
	return MMK_CURVE_P0 * (1 + s / MMK_CURVE_SCALE) ** 2;
}

export function mmkMultipleFromStart(soldWhole: number): number {
	return mmkSpotPrice(soldWhole) / MMK_CURVE_P0;
}

export function mmkOutForUsdm(soldWhole: number, usdmIn: number): number {
	if (usdmIn <= 0) return 0;
	const S = MMK_CURVE_SCALE;
	const a = 1 + Math.max(0, soldWhole) / S;
	const inner = a ** 3 + (3 * usdmIn) / (MMK_CURVE_P0 * S);
	if (inner <= 0) return 0;
	const b = Math.cbrt(inner);
	const s2 = S * (b - 1);
	return Math.max(0, s2 - Math.max(0, soldWhole));
}

export function mmkProgressPct(soldWhole: number, capWhole: number): number {
	if (capWhole <= 0) return 0;
	return Math.min(100, (soldWhole / capWhole) * 100);
}
